export enum FeatureToggle {
    d20250703_studenten_controller_naar_generieke_crud,
    d20250310_Gebruik_nieuw_incassoformaat,
    d20241114_geenmachtigingkenmerk_in_msg120,
    d20250714_comm_approval_id,
    d20211101_VolgOnderwijsVersieMoment,
    d20250627_partner_info_naar_vrije_velden,
    d20250507_vrije_rechten,
    d20250115_FB46887_NHLStendenOnderwijsSoorten,
    d20250415_fontys_fusie_66421,
    d20250711_fix_ns_vinkje_bij_clustering,
    d20220316_simpelere_ui,
    d20241115_GenericEditTable_Webhook,
    d20250703_documenten_confirm_module,
    d20250613_fontys_ds_excie_vestigingen,
    d20250701_datum_definitief_herstelbaar,
    d20250428_erkende_opleiding_datum_van_tot,
    d20191021_koppelen_medewerkers_en_accounts,
    d20250702_edit_studentnotitie_logging,
    d20250625_taaltoets_T1_T2_streng,
    d20250225_foat_project,
    d20250627_verplaatsen_studentvoorziening,
    d20250417_vorderingen_opruimen,
    d20240805_tooltips_zichtbaarder,
    d20250425_geen_oude_machtigingen,
    d20250624_herinschrijving_informatie_tonen,
    d20250501_geen_boekingen_op_correctie_inningfacturen,
    d20250425_sufficientie_filter_vo_status,
    d20250620_Pro6_toon_meer_engels,
    d20250408_ruim_oude_woordenboek_items_op,
    d20211118_menus_pnet_portaal_samenvoegen,
    d20250707_sufficientie_filter_vo_status,
    d20250501_tijdelijke_rechten_profielen,
    d20240130_cohorten_beschikbaar_stellen,
    d20250514_filter_inactieve_studenten,
    toekomst_HeeftWaarschuwingen,
    d20250611_OokStudentLijstenOpOrgFilterenInstelbaar,
    d20250212_Een_niet_reguliere_vorderinggroep,
    d20240830_Beter_scherm_voor_boekingen,
    d20250409_fontys_fusie_66420,
    d20250617_aanmeldsup_extra_tekst,
    d20250612_uitgaand_studielink_bericht_aanbieden,
    d20240207_vrijveld_bulk,
    d20250422_dropdown_highlighting,
    d20240716_VolgMenus,
    d20250425_sufficientie_studiejaar_vanaf,
    d20250321_locaties,
    d20250502_geen_STAP_schermen,
    d20250606_volg_onderwijs_aangeboden_opleiding_koppeling,
    d20250429_academica_waardepapier_specialisatie,
    d20220301_organisatietree_naar_topbar,
    d20210712_intekenitemlijstcontainer,
    d20250616_edu_id_pseudoniem,
    d20250704_aanmeldsupplement_vooropleiding_school_verplicht,
    d20220905_VolgOnderwijsKoppelingConversie,
    d20250129_AVG_feedback,
    d20240904_sl_referentietabellen_automatische_import,
    d20250425_planning_naar_periode,
    d20250331_geen_teverwachten_journalisering,
    d20250626_toestemmingsverklaring_weg,
    d20250106_Grootboekregeldetails,
    d20250220_verwijderen_centraal_geverifieerde_nationaliteit,
    d20250424_nhlstenden_cijferlijst_afronding,
    d20201116_Sta_Vastleggen_Toe,
    d20250611_toon_betalinginfo_bij_afletteren,
    d20250516_datum_einde_instroom,
}
